import { openBlock as t, createElementBlock as e, createStaticVNode as h } from "vue";
const a = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, o = /* @__PURE__ */ h('<path fill="#F0F0F0" d="M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20Z"></path><path fill="#D80027" d="M2.432 10.435h35.136C34.176 4.218 27.581 0 20 0 12.42 0 5.824 4.218 2.432 10.435ZM20 40c7.58 0 14.176-4.218 17.568-10.435H2.432C5.824 35.782 12.419 40 20 40Z"></path><path fill="#FFDA44" d="M26.956 20c0 3.842-3.114 6.087-6.956 6.087-3.842 0-6.957-2.245-6.957-6.087a6.956 6.956 0 1 1 13.913 0Z"></path><path fill="#0052B4" d="M26.956 20a6.956 6.956 0 1 1-13.912 0"></path><path fill="#D80027" d="M15.652 18.26h1.74v3.48h-1.74v-3.48Zm6.957 0h1.739v3.48h-1.74v-3.48Zm-3.479-2.608h1.74v6.087h-1.74v-6.087Z"></path>', 5), l = [
  o
];
function c(n, i) {
  return t(), e("svg", a, [...l]);
}
const r = { render: c };
export {
  r as default,
  c as render
};
